<select class="form-control" [(ngModel)]="week" (ngModelChange)="emitValue()">
  <option [ngValue]="0">First</option>
  <option [ngValue]="1">Second</option>
  <option [ngValue]="2">Third</option>
  <option [ngValue]="3">Fourth</option>
  <option [ngValue]="4">Fifth</option>
  <option [ngValue]="5">Last</option>
</select>